/**
 * @file DeviceEvents.ts
 * @description 设备生命周期事件名称。
 * 先集中声明常用事件，后续逐步替代散落的字符串事件。
 */

export const DeviceEvents = {
  Connected: 'connected',
  Disconnected: 'disconnected',
  Report: 'report',
  /** 命令队列中发生传输层失败（休眠、断连、读写失败等） */
  IoFailed: 'io:failed',
} as const

export type DeviceEventName = (typeof DeviceEvents)[keyof typeof DeviceEvents]
